import { render, staticRenderFns } from "./com-region.vue?vue&type=template&id=73c0c4fb&scoped=true&"
import script from "./com-region.vue?vue&type=script&lang=js&"
export * from "./com-region.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73c0c4fb",
  null
  
)

export default component.exports